import React from 'react';
// logic
import ticketService from '../../ticket-service';
// components
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalBoldText,
} from './modalComponents';
import { FormButton } from '../../ui/buttons/FormButton';
import { withTranslation } from 'react-i18next';

const AcceptQuoteModal = ({ ok, cancel, acceptQuoteModalProps, t }) => {
  const { ticket = {} } = acceptQuoteModalProps;

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };
  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);
  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`${t(
              'accept_modal.subtitle'
            )} ${formattedTicketId}`}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t('accept_modal.title')}</ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <ModalBoldText>{t('accept_modal.warning')}</ModalBoldText>
        </ModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="GHOST" onClick={goBack}>
          {t('accept_modal.back')}
        </FormButton>
        <FormButton onClick={() => ok()}>
          {t('accept_modal.confirm')}
        </FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};

export default withTranslation('Emergencies')(AcceptQuoteModal);
